import {EntityInfoWindow, EntityInfoWindowProps} from "../EntityInfoWindow/EntityInfoWindow";
import {DriverLocationEntity} from "@ots-frontend/ots-data";
import {useTranslation} from "react-i18next";
import {Text} from "@mantine/core";
import {getFormattedDateTime} from "../../../date/FormattedDateTime/FormattedDateTime";
import {getFormattedQuantity} from "../../../text/FormattedQuantity/FormattedQuantity";

export type DriverLocationInfoWindowProps = EntityInfoWindowProps<DriverLocationEntity>

export const DriverLocationInfoWindow = (props: DriverLocationInfoWindowProps) => {
  const {entity: driverLocation, ...rest} = props;

  const {t} = useTranslation("common");

  return (
    <EntityInfoWindow {...rest} entity={driverLocation}>
      <Text>
        {t("ots.ui.entity.driverlocation.map.infowindow.title", "GPS: {{lat}}, {{long}}", {
          lat: driverLocation.latCoord,
          long: driverLocation.longCoord,
        })}
      </Text>
      <Text>
        {
          t("common.entity.driverlocation.map.infowindow.dttm", "Date: {{date}}", {
            date: getFormattedDateTime(driverLocation.createDttm)
          })
        }
      </Text>
      {(driverLocation.speed && driverLocation.speed > 1) && (
        <Text>
          {
            t(
              "common.entity.driverlocation.map.infowindow.speed",
              "Speed: {{speed}}", {
                speed: getFormattedQuantity(driverLocation.speed)
              })
          }
        </Text>
      )}
    </EntityInfoWindow>
  );
};
